import { useDataModel } from '@thd-nucleus/data-sources';
import { getContentfulTargetingIds, useVariationIds } from '@thd-olt-component-react/component-selector';
import { componentMapper } from '../utils/componentMapper';
import { parseContent } from '../utils/utils';
import { validateSlug } from '../utils/hotFixUtils';

export const useHybridPLP = ({
  slug,
  customerType,
  instance,
  skip
}) => {
  const { data, loading, error } = useDataModel('layouts', {
    variables: {
      slug,
      customerType
    },
    ssr: true,
    skip: skip || !validateSlug(slug)
  });

  const layouts = data?.layouts;
  const content = layouts?.content;

  const { mboxes, campaignIds } = getContentfulTargetingIds({ content });
  const isReady = mboxes.length > 0 || campaignIds.length > 0;
  const { variationIds, renderDefault } = useVariationIds({
    mboxes,
    campaignIds,
    isReady
  });

  const customProps = {
    ComponentSelector: (component) => ({
      componentMap: componentMapper.getComponentMap(),
      defaultComponent: component.defaultComponent,
      variations: component.variations,
      variationIds: variationIds || [],
      renderDefault,
      isSeoBot: instance.thdSEOBotDetection,
      targetingType: component.targetingType,
      customPropMap: {
        Spotlight: {
          showDescription: true
        }
      }
    }),
    Spotlight: () => ({
      showDescription: true
    })
  };

  // * Get the parsed data from contentful and set it in a state
  const getParsedContent = (_data) => {
    const { Content } = parseContent({
      data: _data,
      componentMapper,
      customProps
    });

    return Content;
  };

  const contentElements = data ? getParsedContent(data) : null;

  return { contentElements, data, loading, error };
};
